import { List, Table } from "antd"
import { Proposal, approvedProposalAttachment, calculateTotalPrice, defaultRecipient, defaultWorkarea, initialProposalAttachment, workareasToDisplay } from "./proposalsModel"
import moment from "moment"
import { centsToDollarsDisplay } from "../../displayFormatters"
import AttachmentUrl from "./AttachmentUrl"

type Props = {
  pastProposals: Proposal[]
  loading: boolean
  showPastProposals: boolean
}

const ProposalsPastVersions = ({pastProposals, loading, showPastProposals}: Props) => {
  return <div>
   { showPastProposals && <Table
      dataSource={pastProposals.sort((a,b) => b.id - a.id)}
      loading={loading}
      pagination={false}
      rowKey="id"
      locale={{emptyText: 'No Proposals'}}
      columns={[
        {
          title: 'Version',
          key: 'index',
          render: (_text, _record, index) =>  pastProposals.length - index,
        },
        {
          title: 'Created',
          dataIndex: 'initiateDateUtc',
          render: (_, proposal) => {
            return <>
              <span>{proposal.initiateDateUtc ? moment.utc(proposal.initiateDateUtc).local().format("MMM D YYYY h:mma") : null}</span>
              { proposal.initialAttachmentId != null &&
                <span style={{marginLeft: '5px'}}>
                  <AttachmentUrl 
                    attachmentId={proposal.initialAttachmentId!}
                    attachmentType={initialProposalAttachment}
                  />
                </span>
              }
            </>
          }
        },
        {
          title: 'Created By',
          render: (_, proposal) => {
            return proposal.initiatedBy
          }
        },
        {
          title: 'Recipients',
          render: (_, proposal) => {
            return <List
              dataSource={proposal.recipients.length > 0 ? proposal.recipients : [defaultRecipient]}
              renderItem={(recipient) => (
                <List.Item>
                  {recipient.email.toLowerCase()}
                </List.Item>
              )}
            />
          }
        },
        {
          title: 'Workareas (Amount)',
          render: (_, proposal) => {
            return <List
              dataSource={proposal.workareas.length > 0 ? workareasToDisplay(proposal.workareas) : [defaultWorkarea]}
              renderItem={(workarea) => (
                <List.Item>
                  {workarea.name} ({centsToDollarsDisplay(workarea.quotedPrice)})
                </List.Item>
              )}
            />
          }
        },
        {
          title: 'Total Amount',
          render: (_, proposal) => {
            return centsToDollarsDisplay(calculateTotalPrice(proposal.workareas))
          }
        },
        {
          title: 'Approved',
          render: (_, proposal) => {
            return <>
              <span>{proposal.isApproved ? 'Yes' : 'No'}</span>
              { proposal.isApproved && proposal.approvedAttachmentId != null &&
                <span style={{marginLeft: '5px'}}>
                  <AttachmentUrl 
                    attachmentId={proposal.approvedAttachmentId!}
                    attachmentType={approvedProposalAttachment}
                  />
                </span>
              }
            </>
          }
        },
        {
          title: 'Approved Date',
          dataIndex: 'approveDateUtc',
          render: (_, proposal) => {
            return proposal.approveDateUtc ? moment.utc(proposal.approveDateUtc).local().format("MMM D YYYY h:mma") : null
          }
        },
      ]}
    />}
  </div>
}

export default ProposalsPastVersions